export default __webpack_public_path__ + "images/logoSkynIceland.1611c2f7d14fec2d4e728d9ff750f767.svg"